import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { lastValueFrom } from 'rxjs';

import { ButtonDirective, ButtonDirectiveColor } from '../../directives/button.directive';

export type ConfirmationDialogData = {
  header: string;
  contentHeader?: string;
  message: string;
  rejectLabel?: string;
  confirmLabel?: string;
  confirmColor?: ButtonDirectiveColor;
  templateRef?: TemplateRef<unknown>;
  templateRefCtx?: unknown;
};

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [ButtonDirective, TranslateModule, NgTemplateOutlet],
})
export class ConfirmationDialogComponent {
  readonly dialogRef = inject(DynamicDialogRef);

  readonly data: ConfirmationDialogData = inject(DynamicDialogConfig).data;

  static async open(dialog: DialogService, data: ConfirmationDialogData): Promise<boolean> {
    return (await lastValueFrom(
      dialog.open(ConfirmationDialogComponent, {
        data,
        position: 'center',
        showHeader: false,
        styleClass: 'custom-upsert-dialog',
      }).onClose,
    )) as boolean;
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  onReject() {
    this.dialogRef.close(false);
  }
}
